import type { BibleBookId, BibleManifest } from "@packages/sdk";

type Props = { chapter: number; verse: number } & (
  | { bookNumericId: number; book?: never; manifest?: BibleManifest }
  | { bookNumericId?: never; book: BibleBookId; manifest: BibleManifest }
);

export const getBibleVerseId = ({
  chapter,
  verse,
  bookNumericId,
  book,
  manifest,
}: Props) => {
  if (!bookNumericId) {
    bookNumericId = manifest.books.find((bk) => bk.id === book)?.numeric_id;
  }
  if (!bookNumericId) return null;

  return `v${bookNumericId.toString().padStart(2, "0")}${chapter.toString().padStart(3, "0")}${verse.toString().padStart(3, "0")}`;
};
